/**
 * Analytics event catalog shared by backend and frontend. Every PostHog capture on
 * either side uses these names and property keys; the capture helpers (frontend
 * `plugins/analytics.ts`, backend `core/posthog/`) are the only call sites.
 * Runtime values the frontend bundles, so this file imports nothing.
 */

/** Custom event names: object_action, snake_case, present-tense verbs. */
export enum AnalyticsEvent {
   USER_SIGN_IN = 'user_sign_in',
   USER_SIGN_UP = 'user_sign_up',
   ORGANIZATION_CREATE = 'organization_create',
   ORGANIZATION_SWITCH = 'organization_switch',
   MEMBER_INVITE = 'member_invite',
   INVITATION_ACCEPT = 'invitation_accept',
   FOLDER_CREATE = 'folder_create',
   BOARD_CREATE = 'board_create',
   BOARD_FIELD_CREATE = 'board_field_create',
   CARD_CREATE = 'card_create',
}

/** Property keys reused across events, so one fact never ships under two spellings. */
export enum AnalyticsProp {
   ORG_ID = 'org_id',
   BOARD_ID = 'board_id',
   FIELD_TYPE = 'field_type',
   ROLE = 'role',
   APP = 'app',
   ENVIRONMENT = 'environment',
   RELEASE = 'release',
}

/**
 * Capture properties per event. The capture helpers add the standard properties
 * (org, app, environment, release) themselves; callers pass only what is listed here.
 */
export interface IAnalyticsEventProps {
   [AnalyticsEvent.USER_SIGN_IN]: Record<string, never>;
   [AnalyticsEvent.USER_SIGN_UP]: Record<string, never>;
   [AnalyticsEvent.ORGANIZATION_CREATE]: Record<string, never>;
   [AnalyticsEvent.ORGANIZATION_SWITCH]: Record<string, never>;
   [AnalyticsEvent.MEMBER_INVITE]: {[AnalyticsProp.ROLE]: string};
   [AnalyticsEvent.INVITATION_ACCEPT]: {
      [AnalyticsProp.ROLE]: string;
      [AnalyticsProp.ORG_ID]: string;
   };
   [AnalyticsEvent.FOLDER_CREATE]: Record<string, never>;
   [AnalyticsEvent.BOARD_CREATE]: Record<string, never>;
   [AnalyticsEvent.BOARD_FIELD_CREATE]: {[AnalyticsProp.FIELD_TYPE]: string};
   [AnalyticsEvent.CARD_CREATE]: {[AnalyticsProp.BOARD_ID]: string};
}
